// src/api/customHooks/useUploadContactPhoto.ts
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

interface UploadContactPhotoVariables {
  contactId?: string
  formData: FormData
}

const uploadPhoto = async ({ formData }: UploadContactPhotoVariables) => {
  const url = `${baseUrl}/aws/upload-contact-photo`
  console.log('FormData in uploadPhoto:', formData)

  const response = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

const useUploadContactPhoto = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  const mutation = useMutation({
    mutationFn: uploadPhoto,
    onMutate: async ({ contactId, formData }: UploadContactPhotoVariables) => {
      await queryClient.cancelQueries({ queryKey: ['contacts', contactId] })
      const previousContact = queryClient.getQueryData(['contacts', contactId])

      queryClient.setQueryData(['contacts', contactId], (old: any) => ({
        ...old,
        photoUrl: URL.createObjectURL(formData.get('file') as Blob),
      }))

      return { previousContact }
    },
    onError: (err, { contactId }: UploadContactPhotoVariables, context: any) => {
      queryClient.setQueryData(['contacts', contactId], context?.previousContact)
      console.error('Mutation Error:', err)
      showSnackbar((err as any).response?.data?.message || err.message, 'error')
    },
    onSuccess: (_, { contactId }: UploadContactPhotoVariables) => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] })
      showSnackbar('Photo uploaded successfully', 'success')
    },
  })

  return mutation
}

export default useUploadContactPhoto
